/*!

=========================================================
* Black Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {createRef} from "react";
import { Route, Switch } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";

// core components
import AppNavbar from "components/Navbars/AppNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import routes from "routes.js";
import RouterChangePrompt from "../../views/ViewParts/RouterChangePrompt"
import logo from "assets/img/land_logo_sm.png";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import Request from '../../common/Request';
import FaxModal from '../../views/Fax/FaxModal';
import Forbidden from '../../views/ViewParts/Forbidden'

//used for perfect scroll
var ps;

class App extends React.Component {
  constructor(props) {
    super(props);
    
    //overwrite route attribute with role
    const roleData = JSON.parse(GsuiteAuth.get('DATA')) || []
    
    const roleDataMap = (roleData.length&&roleData.length>0)?
    roleData.reduce((acc, roleDatum)=>{
      acc[roleDatum.page_id]=roleDatum
      return acc
    },{})
    :{}
    const roleButtons = JSON.parse(GsuiteAuth.get('BUTTONS')) || []
    const roleDataMapWithButtons = (roleButtons.length&&roleButtons.length>0)?
    roleButtons.reduce((acc, roleButton)=>{
      // console.log(acc[roleButton.page_id])
      if(acc[roleButton.page_id] !== undefined){
        acc[roleButton.page_id].buttons = {
          ...(acc[roleButton.page_id].buttons?acc[roleButton.page_id].buttons:[]),
          [roleButton.button_id]:roleButton
        }
 
      }
      return acc
    }, roleDataMap)
    :{}
    // console.log('roleDataMapWithButtons', roleDataMapWithButtons)
    this.state = {
      activeColor: "blue",
      sidebarMini: true,
      opacity: 0,
      sidebarOpened: false,
      routesWithRole: routes.map((route)=>{
        if(route.collapse !== undefined){
          let temp_view = []
          route.views.map((view)=>{
            return temp_view.push({
              ...view,
              ...(roleDataMap[view.page_id]),
              ...(roleDataMapWithButtons[view.page_id]),
            })
           
          })

          let tmp_route ={
            ...route,
            ...(roleDataMap[route.page_id]),
            ...(roleDataMapWithButtons[route.page_id]),
            views: temp_view
          }
          // console.log(tmp_route)
          return tmp_route
        } else {
          return {
            ...route,
            ...(roleDataMap[route.page_id]),
            ...(roleDataMapWithButtons[route.page_id]),
          }  
        }
      }),
      new_arrivals_count:{},
      faxModal:React.createRef(),
      loadingProcessFlag: false
    };
    // console.log(this.state.routesWithRole)

    this.appNavBarRef = createRef();
    
  }
  componentDidMount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   document.documentElement.className += " perfect-scrollbar-on";
    //   document.documentElement.classList.remove("perfect-scrollbar-off");
    //   ps = new PerfectScrollbar(this.refs.mainPanel);
    //   let tables = document.querySelectorAll(".table-responsive");
    //   for (let i = 0; i < tables.length; i++) {
    //     ps = new PerfectScrollbar(tables[i]);
    //   }
    // }
    window.addEventListener("scroll", this.showNavbarButton);
    // console.log("main");
    this.refreshTaskCount();
  }
  componentWillUnmount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps.destroy();
    //   document.documentElement.className += " perfect-scrollbar-off";
    //   document.documentElement.classList.remove("perfect-scrollbar-on");
    // }
    window.removeEventListener("scroll", this.showNavbarButton);
  }
  componentDidUpdate(e) {
    if ((e.location.pathname != undefined && e.location.pathname !== e.history.location.pathname) ||
        (e.location.action == "PUSH" && e.location.location.pathname !== e.history.location.pathname)) {
      if (navigator.platform.indexOf("Win") > -1) {
        let tables = document.querySelectorAll(".table-responsive");
        for (let i = 0; i < tables.length; i++) {
          ps = new PerfectScrollbar(tables[i]);
        }
      }
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;

      // 画面遷移時にカウントリフレッシュ
      this.refreshTaskCount();
    }
  }
  showNavbarButton = () => {
    if (
      document.documentElement.scrollTop > 50 ||
      document.scrollingElement.scrollTop > 50 ||
      this.refs.mainPanel.scrollTop > 50
    ) {
      if(this.state.opacity === 1){
        return;
      }
      this.setState({ opacity: 1 });
    } else if (
      document.documentElement.scrollTop <= 50 ||
      document.scrollingElement.scrollTop <= 50 ||
      this.refs.mainPanel.scrollTop <= 50
    ) {
      this.setState({ opacity: 0 });
    }
  };
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if(prop.path === undefined){
        console.log(prop);
        return <>
          {prop.name}
        </>;
      }else{
        const needAlertPageIds = [
          "A1_02","A1_04","A2_01","A2_03","AX_01","AX_03"
          ,"C2_01","E1_02","FX_02","M1_02","M1_03","M1_04"
          ,"M1_08","M1_09","M1_10","M2_02","M2_04","M3_02"
          ,"M3_04","J1_02","H1_02", "M4_02", "M4_04"
        ]
        
        return (
          <Route exact 
            path={prop.path}
            // component={prop.component}
            key={key}
            render={(props)=>{
              const Component = prop.component
              let pageChangeAlert = React.createRef();
              // console.log(prop.data_view_flag);
              return  prop.data_view_flag&&prop.data_view_flag>0
              ?(<>
                {needAlertPageIds.includes(prop.page_id)
                &&<RouterChangePrompt
                  ref={pageChangeAlert}
                />}
                <Component {...props} {...prop} 
                  pageChangeAlert={pageChangeAlert} 
                  alertModal={this.props.alertModal} 
                  faxModal = {this.state.faxModal}
                  refreshTaskCount={this.refreshTaskCount}
                  new_arrivals_count={this.state.new_arrivals_count}
                  reloadUnread={this.reloadUnread}
                  />
              </>)
              :(
                <Forbidden/>
              )
            }}
          />
          )
      }
    });
  };
  getActiveRoute = routes => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  handleActiveClick = color => {
    this.setState({ activeColor: color });
  };
  handleMiniClick = () => {
    let notifyMessage = "Sidebar mini ";
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
      notifyMessage += "deactivated...";
    } else {
      this.setState({ sidebarMini: true });
      notifyMessage += "activated...";
    }
    let options = {
      place: "tr",
      message: notifyMessage,
      type: "primary",
      icon: "tim-icons icon-bell-55",
      autoDismiss: 7
    };
//    this.refs.notificationAlert.notificationAlert(options);
    document.body.classList.toggle("sidebar-mini");
  };
  toggleSidebar = () => {
    this.setState({
      sidebarOpened: !this.state.sidebarOpened
    });
    document.documentElement.classList.toggle("nav-open");
  };
  closeSidebar = () => {
    this.setState({
      sidebarOpened: false
    });
    document.documentElement.classList.remove("nav-open");
  };
  refreshTaskCount = (refresh = false) => {
    try {
      if ( refresh === true ) {
        throw "refreshCount"
      }
      let stringfyTaskCount = GsuiteAuth.get("taskCount");

      if ( stringfyTaskCount == null ) {
        throw "noneLocalStorageData"
      }
      let taskCount = JSON.parse(stringfyTaskCount)
      this.setState({new_arrivals_count: taskCount});
    }
    catch ( e ) {
//      console.log(e);
      if (this.state.loadingProcessFlag === true) { return ; }
      const login_user_id = localStorage.id
      const user_branch_id = localStorage.user_branch_id
      this.setState({loadingProcessFlag:true},()=>{
        Request.get('/api/task',{login_user_id: login_user_id, user_branch_id: user_branch_id}, res => {
          GsuiteAuth.set("taskCount", JSON.stringify(res.Data));
          this.setState({new_arrivals_count: res.Data,loadingProcessFlag:false});
          }, () => {}, () => {}, true, false, false
        )
      });
    }
  }
  reloadUnread = () => {
    this.appNavBarRef.current.fetchUnread();
  }
  render() {

    let pathname = this.props.location.pathname ? this.props.location.pathname : window.location.pathname;
    // console.log(this.state.routesWithRole)
    return (
      <div className="wrapper">
        <div className="rna-container">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div
          className="navbar-minimize-fixed"
          style={{ opacity: this.state.opacity }}
        >
          <button
            className="minimize-sidebar btn btn-link btn-just-icon"
            onClick={this.handleMiniClick}
          >
            <i className="tim-icons icon-align-center visible-on-sidebar-regular text-muted" />
            <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted" />
          </button>
        </div>
        <Sidebar
          {...this.props}
          routes={this.state.routesWithRole}
          activeColor={this.state.activeColor}
          logo={{
            outterLink: "#",
            text: this.getActiveRoute(routes),
            imgSrc: logo
          }}
          closeSidebar={this.closeSidebar}
          pushRefreshTaskCount={()=>{this.refreshTaskCount(true)}}
          new_arrivals_count={this.state.new_arrivals_count}
        />
        <div
          className="main-panel"
          ref="mainPanel"
          data={this.state.activeColor}
        >
          <AppNavbar
            ref={this.appNavBarRef}
            {...this.props}
            handleMiniClick={this.handleMiniClick}
            brandText="Landmark"
            sidebarOpened={this.state.sidebarOpened}
            toggleSidebar={this.toggleSidebar}
          />
          <Switch>{this.getRoutes(this.state.routesWithRole)}</Switch>
          {// we don't want the Footer to be rendered on full screen maps page
          pathname.indexOf("full-screen-map") !==
          -1 ? null : (
            <Footer fluid />
          )}
        </div>
        <FaxModal
          ref={this.state.faxModal}
          default_footer={true}
          {...this.props}
        />
      </div>
    );
  }
}

export default App;
